"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Placeholder = function Placeholder(props) {
  var poster = props.poster;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "video-js vjs-big-play-centered vjs-paused vjs-fluid vjs_video_3-dimensions vjs-controls-enabled vjs-workinghover vjs-v7 vjs-user-active",
    style: poster ? {
      backgroundImage: "url(".concat(poster, ")"),
      backgroundSize: 'cover'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "vjs-big-play-button",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "vjs-icon-placeholder",
    "aria-hidden": "true"
  })));
};
var _default = exports["default"] = Placeholder;